import React, { useEffect, useState } from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import UserDetailsPage from "../../UI/Users/UserDetails";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";

const UserDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const getData = async () => {
    setIsLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.Users.ViewUserDetails}${id}`,
      hasToken: true,
    });
    if (response) {
      setData(response?.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              User details <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>{data?.name}</div>
              <span
                className={`badge w-24 text-darkTextColor ${
                  data?.active ? "bg-[#28a745]" : "bg-[#ff6877]"
                }`}
              >
                {data?.active ? "active" : "not active"}
              </span>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress sx={{ marginTop: 1 }} />
          ) : (
            <UserDetailsPage data={data} isLoading={isLoading} />
          )
        }
      />
    </div>
  );
};

export default UserDetails;
